export class UserAllLogRequestModel {
  FirmId: number;
  UserId: number;
}
